
import { setCookie, removeCookie } from '../util/cookies';

const COOKIE_TIMEOUT = 5184000;

const reducers = {
  /**
  * GENERAL REDUCERS STYLES
  */

  PATHNAME: (state, payload) => {
    return {
      ...state,
      pathname: payload.pathname
    };
  },

  ERROR: (state, { error, code }) => {
    console.log("ERROR_reducer")
    console.log(error)
    return {
      ...state,
      error: { code, exist: true, message: error },
    };
  },

  SIGNIN_USER: (state, payload) => {
    const { user, token } = payload.response
    localStorage.setItem('user', JSON.stringify(user))
    setCookie('token', `Bearer ${token}`, COOKIE_TIMEOUT);
    // localStorage.setItem('token', JSON.stringify(token))
    return {
      ...state,
      authUser: user
    };
  },

  SIGNOUT_USER: (state, payload) => {
    localStorage.removeItem("user")
    removeCookie('token');
    // localStorage.removeItem("token")
    return {
      ...state,
      authUser: null,
      initURL: '/',
      loader: false
    };
  },

  INIT_URL: (state, payload) => {
    return {
      ...state,
      initURL: payload.url,
    };
  },
}
export default reducers;
